export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const Result_Pre_Page = 10;
